import { get } from 'lodash-es';
import { getApiEndpoint } from 'srcAlias/utils/url';
import { createHeaders } from 'srcAlias/utils/headers';
import config from 'configAlias';
import { connect } from 'react-redux';

export const callErrorLogApi = ({
  errorMessage,
  errorInfo,
  journeyStageCause,
  sessionId,
}) => {
  const appConfig = get(config, 'appConfig', {});
  const headersDetails = {
    applicationType: get(appConfig, 'applicationType'),
    channelId: get(appConfig, 'channelId'),
    sessionId: sessionId,
    countryCode: get(appConfig, 'countryCode'),
    groupMember: get(appConfig, 'groupMember'),
  };

  const apiEndpoint = getApiEndpoint();
  const opts = {
    errorMessage,
    errorInfo,
    journeyStageCause,
    sessionId,
  };

  const parsedData = JSON.stringify(opts);

  fetch(`${apiEndpoint}/api/etb/error/`, {
    method: 'POST',
    headers: {
      ...createHeaders(headersDetails),
      'content-type': 'application/json',
    },
    body: parsedData,
  });
};

const mapStateToProps = (state) => {
  return {
    sessionId: get(state, 'sessionId', 'ERROR_CREATING_SESSION_ID'),
  };
};

export default connect(mapStateToProps)(callErrorLogApi);
